import {
  GET_ALL_CONTACTS,
  GET_ALL_CONTACTS_FULFILLED,
  CONTACTS_CLEAR_ERRORS,
  OPEN_CONTACT_CREATE_POPUP,
  CLOSE_CONTACT_CREATE_POPUP,
  CREATE_CONTACT_FULFILLED,
  SET_CONTACT_LOADING,
  SELECT_CONTACT,
  GET_CONTACT_BY_ID_FULFILLED,
} from './contact.actions';
import { adaptContactListFromServer } from './contact.adapters';
import { ContactState } from './contact.types';

const defaultState = {
  contacts: [],
  selectedIndex: null,
  createdId: null,
  single: null,
  creatingContact: null,
  error: null,
  selected: [],
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  }
};

const moduleReducer = (state = defaultState, action: any): ContactState => {
  if (/CONTACT.*_REJECTED/.test(action.type)) {
    return { ...state, error: action.payload.message };
  }
  switch (action.type) {
    case GET_ALL_CONTACTS:
      return {
        ...state,
        selected: [],
        single: null,
      };

    case GET_ALL_CONTACTS_FULFILLED:
      return {
        ...state,
        contacts: adaptContactListFromServer(action.payload.data.data),
        selected: [],
        single: null,
      };

    case GET_CONTACT_BY_ID_FULFILLED:
      return { ...state, single: adaptContactListFromServer(action.payload.data.data) };

    case CONTACTS_CLEAR_ERRORS:
      return { ...state, error: null };
    case OPEN_CONTACT_CREATE_POPUP:
      return {
        ...state,
        single: adaptContactListFromServer([action.payload.contact]) ?? null,
        creatingContact: action.payload.contact ?? null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };
    case CLOSE_CONTACT_CREATE_POPUP:
      return {
        ...state,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };
    case SET_CONTACT_LOADING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };
    case CREATE_CONTACT_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case SELECT_CONTACT:
      return {
        ...state,
        selected: action.payload ?? [],
      };
    default:
      return state;
  }
};
export default moduleReducer;
